import { withRouter } from 'react-router-dom'
import { SearchFilters as Component } from './SearchFilters'

export const SearchFilters = withRouter(Component)
